/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElRow as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/row/style/css';
import { ElCol as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/col/style/css';
import { ElRadioGroup as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("分成");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导量");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("收款信息：");
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确定");
import { apiUsdkCpsUpdateDistributeChannel, apiUsdkCpsCreateChannel, apiUsdkGetAndChannelList } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const dialogVisible = ref(false);
    const editConfirmLoading = ref(false);
    const channel = ref([]);
    const ruleForm = ref();
    const editForm = ref({
      id: '',
      name: '',
      cid: '',
      cooperateType: undefined,
      companyName: '',
      divided: '',
      receiptName: '',
      receiptCardNo: '',
      receiptBankName: '',
      receiptBankBranch: ''
    });
    const initForm = () => {
      editForm.value = {
        id: '',
        name: '',
        cid: '',
        cooperateType: undefined,
        companyName: '',
        divided: '',
        receiptName: '',
        receiptCardNo: '',
        receiptBankName: '',
        receiptBankBranch: ''
      };
    };
    const handleClose = formEl => {
      dialogVisible.value = false;
      initForm();
      if (formEl) {
        formEl.resetFields();
      }
    };
    const getAndChannel = () => {
      apiUsdkGetAndChannelList({}).then(res => {
        if (res.code === 0) {
          channel.value = res.data;
        }
      });
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          editConfirmLoading.value = true;
          let params = {
            id: editForm.value.id,
            name: editForm.value.name,
            companyName: editForm.value.companyName,
            cooperateType: editForm.value.cooperateType,
            cid: editForm.value.cid,
            divided: editForm.value.divided
          };
          if (editForm.value.cooperateType === 1) {
            params.receiptName = editForm.value.receiptName;
            params.receiptCardNo = editForm.value.receiptCardNo;
            params.receiptBankName = editForm.value.receiptBankName;
            params.receiptBankBranch = editForm.value.receiptBankBranch;
          }
          let api = editForm.value.id ? apiUsdkCpsUpdateDistributeChannel : apiUsdkCpsCreateChannel;
          api(params).then(res => {
            if (res.code === 0) {
              emits('success');
              handleClose(ruleForm.value);
            }
          }).finally(() => {
            editConfirmLoading.value = false;
          });
        }
      });
    };
    const show = data => {
      if (data) {
        editForm.value = {
          ...data
        };
      }
      dialogVisible.value = true;
      getAndChannel();
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_radio = __unplugin_components_4;
      const _component_el_radio_group = __unplugin_components_5;
      const _component_el_col = __unplugin_components_6;
      const _component_el_row = __unplugin_components_7;
      const _component_el_form = __unplugin_components_8;
      const _component_el_button = __unplugin_components_9;
      const _component_el_dialog = __unplugin_components_10;
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: editForm.value.id ? '编辑' : '创建',
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => dialogVisible.value = $event),
        width: "600px",
        "before-close": () => handleClose(ruleForm.value)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: editConfirmLoading.value,
          onClick: _cache[10] || (_cache[10] = $event => handleOk(ruleForm.value))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleForm",
          ref: ruleForm,
          model: editForm.value,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "渠道名称",
            prop: "name",
            rules: [{
              required: true,
              message: '请输入渠道名称',
              trigger: 'change'
            }, {
              max: 10,
              message: '不超过十个字符'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入渠道名称",
              modelValue: editForm.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => editForm.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "分类归属",
            prop: "cid",
            rules: {
              required: true,
              message: '请选择分类归属',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: editForm.value.cid,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editForm.value.cid = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channel.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  value: item.id,
                  key: item.id,
                  label: item.name
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合作方式",
            prop: "cooperateType",
            rules: {
              required: true,
              message: '请选择合作方式',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: editForm.value.cooperateType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => editForm.value.cooperateType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "渠道公司名称",
            prop: "companyName",
            rules: {
              required: editForm.value.cooperateType === 1,
              message: '请输入渠道公司名称',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入渠道公司名称",
              modelValue: editForm.value.companyName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => editForm.value.companyName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            label: "分成比例",
            prop: "divided",
            rules: {
              required: editForm.value.cooperateType === 1,
              message: '请输入分成比',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.value.divided,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => editForm.value.divided = $event),
              placeholder: "输入分成比，例：5:5"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), editForm.value.cooperateType === 1 ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 5,
              style: {
                "text-align": "right"
              }
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), editForm.value.cooperateType === 1 ? (_openBlock(), _createBlock(_component_el_row, {
            key: 1
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              offset: 5,
              span: 19
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "收款方户名",
                prop: "receiptName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: editForm.value.receiptName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => editForm.value.receiptName = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              offset: 5,
              span: 19
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "银行卡号",
                prop: "receiptCardNo"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: editForm.value.receiptCardNo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => editForm.value.receiptCardNo = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              offset: 5,
              span: 19
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "开户行"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  style: _normalizeStyle({
                    display: 'inline-block',
                    width: 'calc(50% - 5px)',
                    marginRight: '10px'
                  })
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: editForm.value.receiptBankName,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => editForm.value.receiptBankName = $event),
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }, 8, ["style"]), _createVNode(_component_el_form_item, {
                  style: _normalizeStyle({
                    display: 'inline-block',
                    width: 'calc(50% - 5px)'
                  })
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: editForm.value.receiptBankBranch,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => editForm.value.receiptBankBranch = $event),
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }, 8, ["style"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "modelValue", "before-close"]);
    };
  }
});